module.exports = __webpack_public_path__ + "img/green.bd459859.jpg";